package com.partejar.app.core.session

class SessionInvalidException : Exception()

class SessionTemporarilyUnavailableException : Exception()
